import {inject} from '@angular/core';
import {uniq} from 'lodash';
import {getCellName} from 'src/app/diagram-render/helpers/shapes-detectors.util';
import {EditorRegistryService} from 'src/app/diagram-render/mx-graph/editor/editor-registry.service';
import {
  drilldownActions,
  MAPS_TYPES_ENUM as MAP_TYPES
} from '../../editor-interface/shared/models/map.model';
import {DiagramTypeConfigService} from '../../core/services/diagram-type-config.service';
import {menuItems, subMenu} from '../context-menu/menu-items';

export abstract class BaseContextTool {
  protected readonly registry = inject(EditorRegistryService);
  protected readonly diagramTypeConfigService = inject(DiagramTypeConfigService);

  protected get graph() {
    return this.registry.getGraph();
  }

  public get isSelected() {
    const selectionCount = this.graph.getSelectionCount();

    return {
      one: selectionCount === 1,
      some: selectionCount > 0,
      nothing: selectionCount === 0
    };
  }

  public getSelectionNames() {
    const selection = this.graph.getSelectionCells();

    return uniq(selection.map(cell => getCellName(cell ?? {})));
  }

  protected getDrilldownMenuItems() {
    const {allowedDrilldownSubtypes} = this.diagramTypeConfigService.generalSettings();

    if (!allowedDrilldownSubtypes?.length) {
      return [];
    }

    const drilldownSubtypeItems = allowedDrilldownSubtypes.map(subtype => {
      return subtype === MAP_TYPES.UPN
        ? {
            title: menuItems.newDrilldown,
            items: [drilldownActions[subtype], menuItems.autoGenerateDrilldown]
          }
        : drilldownActions[subtype];
    });

    return [...drilldownSubtypeItems, ...subMenu.drilldown.items];
  }
}
